import i18next from "i18next";
import { InvoiceStatus } from "../../graphql/generated";

function invoiceStatusLabel(status: InvoiceStatus) {
  return i18next.t(`finance:invoiceStatusEnum.${status}`) as string;
}

export default invoiceStatusLabel;
